import { ProductEntrySchema } from '#app/routes/mocra+/_form+/components/products/schema.ts'
import {
	collectProductErrors,
	createProductDraft,
	productDraftToEntry,
	productEntryToDraft,
	sanitizeProductDraft,
	type ProductDraft,
} from '#app/routes/mocra+/_form+/components/products/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const productDefinition = assertEntityDefinition({
	schema: ProductEntrySchema,
	createDraft: () => createProductDraft(),
	sanitizeDraft: sanitizeProductDraft,
	serialize: productDraftToEntry,
	deserialize: productEntryToDraft,
	collectErrors: collectProductErrors,
})

export type ProductEntityDraft = ProductDraft
